import { render, staticRenderFns } from "./TipDetailsPage.vue?vue&type=template&id=eca2155e&"
import script from "./TipDetailsPage.vue?vue&type=script&lang=js&"
export * from "./TipDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports